import { useMediaQuery, Grid, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';

const useStyles = makeStyles(() => ({
  image: {
    maxWidth: 560,
  },
}));

const About = props => {
  const { className, onJobsList, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <div className={className} {...rest}>
      <Grid
        container
        justifyContent="space-between"
        spacing={isMd ? 4 : 2}
        direction={isMd ? 'row' : 'column-reverse'}>
        <Grid
          item
          container
          alignItems="center"
          justifyContent="flex-start"
          xs={12}
          md={6}
          data-aos="fade-up">
          <div>
            <SectionHeader
              title="Quer trabalhar com a gente?"
              subtitle="Estamos sem em busca de pessoas que tenham a mesma determinação em superar desafios e tornar a educação do nosso país, melhor. Confira as vagas abertas e se candidate para aquela que tem mais a sua cara."
              align="left"
              disableGutter
              subtitleProps={{
                color: 'textPrimary',
                variant: 'body1',
              }}
              ctaGroup={[
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  onClick={onJobsList}
                  aria-label="Vagas abertas"
                  key="openJobsCta">
                  Vagas abertas
                </Button>,
              ]}
            />
          </div>
        </Grid>
        <Grid
          item
          container
          justifyContent={isMd ? 'flex-end' : 'flex-start'}
          alignItems="center"
          xs={12}
          md={6}
          data-aos="fade-up">
          <Image
            src="/images/illustrations/careers/feature-1.svg"
            width="100%"
            alt="Vagas abertas"
            className={classes.image}
          />
        </Grid>
      </Grid>
    </div>
  );
};

About.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Click to view jobs list
   */
  onJobsList: PropTypes.func,
};

export default About;
